import { render, staticRenderFns } from "./PreorderDetail.vue?vue&type=template&id=1940e3e4&scoped=true&class=preorder-modal&"
import script from "./PreorderDetail.vue?vue&type=script&lang=js&"
export * from "./PreorderDetail.vue?vue&type=script&lang=js&"
import style0 from "./PreorderDetail.vue?vue&type=style&index=0&id=1940e3e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1940e3e4",
  null
  
)

export default component.exports